import { render, staticRenderFns } from "./asideContent.vue?vue&type=template&id=5132b073&scoped=true"
import script from "./asideContent.vue?vue&type=script&lang=js"
export * from "./asideContent.vue?vue&type=script&lang=js"
import style0 from "./asideContent.vue?vue&type=style&index=0&id=5132b073&prod&lang=scss&scoped=true"
import style1 from "./asideContent.vue?vue&type=style&index=1&id=5132b073&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132b073",
  null
  
)

export default component.exports